'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function prepend() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return function () {
    var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return [prefix, str].join('');
  };
}

exports.default = prepend;
//# sourceMappingURL=prepend.js.map
